module.exports = __webpack_public_path__ + "static/media/google-play.f3680376.svg";